<!-- src/components/LanguageDropdown.vue -->
<script setup lang="ts">
import { computed } from 'vue'; // 如果你启用了 i18n
import { useSystemConfigStoreHook } from '@/store/modules/systemConfig';
import { Lang } from '@/config';
import { i18n} from '@/plugins';
import { CommonUtils } from "@/utils/commonUtils";
import { useRouter } from 'vue-router';
import { initRouter } from '@/router';

// 1. 拿到 Store
const sysStore = useSystemConfigStoreHook();
const router = useRouter();

// 3. 支持的语言
const langList = computed(() => sysStore.commonConfig.lang ?? [Lang.LAN_CN]); 

// 4. 当前语言
const currentLang = computed(() => sysStore.currentLang);

// 5. 切换语言
async function changeLang(lang: Lang) {
  // 用 Store 提供的方法，一步到位地写入 state + localStorage
  sysStore.setLang(lang);
  i18n.global.locale.value = lang;
  // 2. 重新生成动态路由
  const currentPath = router.currentRoute.value.fullPath; // 保存当前路径
  await initRouter(); // 重新初始化动态路由

  // 3. 保持当前路由位置
  const newRoute = router.resolve(currentPath);
  if (newRoute.matched.length > 0) {
    router.replace(newRoute);
  } else {
    router.replace('/'); // 回退到首页
  }
  // 更新当前路由的标题
  const currentRoute = router.currentRoute.value;
  if (currentRoute.meta.title) {
    document.title = CommonUtils.transformI18n(currentRoute.meta.title);
  }
  emit('updateLang');
}
const emit = defineEmits(['updateLang']);
</script>

<template>
  <div class="flex z-[999] items-center space-x-1 cursor-pointer">
    <!-- 简体 -->
    <span
      v-if="langList.includes(Lang.LAN_CN)"
      @click="changeLang(Lang.LAN_CN)"
      :class="{ 'text-main-primary': currentLang === Lang.LAN_CN }"
      class="hover:text-main-primary hover:scale-110 transition-all duration-300"
    >
      简
    </span>
    <span v-if="langList.includes(Lang.LAN_CN)">/</span>
    <!-- 繁体 -->
    <span
      v-if="langList.includes(Lang.LAN_TW)"
      @click="changeLang(Lang.LAN_TW)"
      :class="{ 'text-main-primary': currentLang === Lang.LAN_TW }"
      class="hover:text-main-primary hover:scale-110 transition-all duration-300"
    >
      繁
    </span>
    <span v-if="langList.includes(Lang.LAN_TW)">/</span>

    <!-- 英文 -->
    <span
      v-if="langList.includes(Lang.LAN_EN)"
      @click="changeLang(Lang.LAN_EN)"
      :class="{ 'text-main-primary': currentLang === Lang.LAN_EN }"
      class="hover:text-main-primary hover:scale-110 transition-all duration-300"
    >
      EN
    </span>
    <span v-if="langList.includes(Lang.LAN_RM)">/</span>
    <!-- 英文 -->
      <span
      v-if="langList.includes(Lang.LAN_RM)"
      @click="changeLang(Lang.LAN_RM)"
      :class="{ 'text-main-primary': currentLang === Lang.LAN_RM }"
      class="hover:text-main-primary hover:scale-110 transition-all duration-300"
    >
     BM
    </span>
  </div>
</template>

<style scoped>
.hover\:text-main-primary:hover {
  color: var(--el-color-primary);
}

.text-main-primary {
  color: var(--el-color-primary);
}
</style>
